import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import Users from '@/views/Users.vue'
import SystemSelection from '@/views/SystemSelection.vue'
import store from '@/store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      requiresAuth: false,
    },
  },
  {
    path: '/home',
    name: 'system-selection',
    component: SystemSelection,
    meta: {
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
     
        store.dispatch('isAuthenticated').then((response) => {
          next()
        }).catch((error) => {
          next('/')
          localStorage.clear()
        })

    }
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    meta: {
      requiresAuth: true,
    },
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  if(to.meta.requiresAuth && !localStorage.getItem('landing_token')){
    next('/')
  }
  else if(!to.meta.requiresAuth && localStorage.getItem('landing_token')){
    next('/home')
  }else{
    next()
  }
})

export default router